export function capitalizeSentence(sentence: string): string {
  return sentence.charAt(0).toUpperCase() + sentence.slice(1)
}

export function capitalizeAllWords(sentence: string, separator = ' '): string {
  return sentence.toLowerCase().split(separator).map(capitalizeSentence).join(separator)
}
